import type { EUROPACE_OFFERS_SYNCHRONIZATION_STATUS } from 'cpool-constants';
import { EUROPACE_OFFERS_SYNCHRONIZATION_STATUSES } from 'cpool-constants';
import type { SchemaLoanRequestResolver_GetOffersSynchronizationStatus } from 'cpool-tables/backend-resolvers';
import { schemaLoanRequestResolver_GetOffersSynchronizationStatus } from 'cpool-tables/backend-resolvers';
import type { TFunction } from 'i18next';
import { toast } from 'react-toastify';

import { showSynchronizationToastError } from './showSynchronizationToastError';
import { fetcher } from '~/queryUtils/useQuery';

export const verifyOffersSynchronizationStatus = async ({
    loanRequestId,
    t,
}: {
    loanRequestId: string;
    t: TFunction<'de' | 'en', undefined>;
}): Promise<EUROPACE_OFFERS_SYNCHRONIZATION_STATUS | null> => {
    try {
        const response: SchemaLoanRequestResolver_GetOffersSynchronizationStatus = await fetcher({
            meta: {
                queryUrl: `/query/loan-request/getOffersSynchronizationStatus?id=${loanRequestId}`,
                schema: schemaLoanRequestResolver_GetOffersSynchronizationStatus,
            },
        });
        if (!response) {
            toast.error(t('OFFER_MANAGEMENT.OFFERS_SYNCHRONIZATION.TOASTS.NOT_IMPORTED'));
            return null;
        }

        switch (response.status) {
            case EUROPACE_OFFERS_SYNCHRONIZATION_STATUSES.FINISHED:
                toast.success(t('OFFER_MANAGEMENT.OFFERS_SYNCHRONIZATION.TOASTS.SUCCESS'));
                break;
            case EUROPACE_OFFERS_SYNCHRONIZATION_STATUSES.FAILED:
                if (response?.warning) {
                    showSynchronizationToastError(response?.warning, t);
                } else {
                    toast.error(t('OFFER_MANAGEMENT.OFFERS_SYNCHRONIZATION.TOASTS.SYNC_FAILED'));
                }
                break;
            case EUROPACE_OFFERS_SYNCHRONIZATION_STATUSES.STARTED:
                toast.info(t('OFFER_MANAGEMENT.OFFERS_SYNCHRONIZATION.TOASTS.PENDING'));
                break;
            default:
                toast.error(t('OFFER_MANAGEMENT.OFFERS_SYNCHRONIZATION.TOASTS.NOT_IMPORTED'));
        }
        return response.status;
    } catch (e) {
        toast.error(t('OFFER_MANAGEMENT.OFFERS_SYNCHRONIZATION.TOASTS.SYNC_FAILED'));
        return null;
    }
};
